// extracted by mini-css-extract-plugin
export var alignCenter = "_9f-d";
export var bannerShown = "_9f-6";
export var buttonContent = "_9f-0";
export var cardList = "_9f-1";
export var centerContent = "_9f-2";
export var chevron = "_9f-3";
export var closePanelButton = "_9f-k";
export var conversationContextContainer = "_9f-l";
export var conversationDetailContainer = "_9f-4";
export var detailWrapper = "_9f-7";
export var dropdownButton = "_9f-e";
export var dropdownTitle = "_9f-9";
export var fullHeight = "_9f-5";
export var hidden = "_9f-a";
export var icon = "_9f-b";
export var mergeSuggestionWrapper = "_9f-m";
export var panel = "_9f-i";
export var portalButtonsWrapper = "_9f-c";
export var right = "_9f-j";
export var tableSummaryContainer = "_9f-8";
export var tableSummaryHeader = "_9f-g";
export var threeDotsButton = "_9f-f";
export var wide = "_9f-h";